import { getDataMapper, mapField, mapArray } from "@/shared";

export const mapPointFromServer = getDataMapper({
    id: mapField("id", Number),
    title: mapField("title"),
    email: mapField("email"),
    website: mapField("website"),
    phone: mapField("phone"),
    address: mapField("place_text"),
});

export const mapPointsFromServer = mapArray(mapPointFromServer);
